//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { NsIcon } from '@nuskin/ns-icon';
import { VSheet, VBottomSheet } from 'vuetify/lib';
export default {
  name: 'NsToast',
  components: {
    VBottomSheet,
    VSheet,
    NsIcon,
  },
  props: {
    /**
     * Applies green color to the toast
     */
    success: { type: Boolean, default: false },
    /**
     * Applies red color to the toast
     */
    error: { type: Boolean, default: false },
    /**
     * Applies yellow color to the toast
     */
    info: { type: Boolean, default: false },
    /**
     * Applies yellow color to the toast
     */
    warning: { type: Boolean, default: false },
    /**
     * Adds icon that is relevant to a toast type (success, info, warning, error)
     */
    icon: { type: Boolean, default: false },
    /**
     * Clicking outside of the element will not deactivate it
     */
    persistent: { type: Boolean, default: false },
    /**
     * Toggles only after user selects an action (applicable only for CTA toast)
     */
    forcedCTA: { type: Boolean, default: false },
    /**
     * Allows to use slot with custom html
     */
    custom: { type: Boolean, default: false },
    /**
     * Message inside toast
     */
    message: { type: String, default: '' },
    /**
     * Timout after which toast will deactivate
     */
    delay: { type: Number, default: 5000 },
    /**
     * Call to action link text
     */
    ctaLink: { type: String, default: '' },
    /**
     * Call to action button caption
     */
    ctaButton: { type: String, default: '' },
    /**
     * List of actions. Example:
     * {
     *  title: 'Select Action',
     *  subtitle: 'You can have a subtitle if you'd like.'
     *  items: [{text: 'Primary CTA', id: 'unique-key'}, ...]
     * }
     */
    ctaList: {
      type: Object,
      default: () => {
        return {
          title: '',
          subtitle: '',
          items: [],
        };
      },
    },
    /**
     * Triggers toast activation on value change (Hint: to make toast show do showTrigger = !showTrigger)
     */
    showTrigger: { type: [Boolean, String], default: false },
    /**
     * Fires when any CTA is clicked. Passes id of a clicked cta
     */
    onCtaClick: { type: Function, default: () => {} },
  },
  data() {
    return {
      timeout: null,
      showToast: null,
      showCtaList: null,
    };
  },

  computed: {
    statusIcon() {
      let icon = '';
      switch (true) {
        case this.success:
          icon = 'success';
          break;
        case this.error:
          icon = 'error';
          break;
        case this.warning:
          icon = 'warning';
          break;
        case this.info:
          icon = 'info';
          break;
      }
      return `icon-${icon}-filled`;
    },
  },

  watch: {
    showTrigger() {
      clearTimeout(this.timeout);
      this.showToast = true;
      if (this.persistent) {
        return;
      }
      this.timeout = setTimeout(() => {
        this.showToast = false;
        clearTimeout(this.timeout);
      }, this.delay);
    },
    showCtaList(val) {
      if (val) {
        this.$refs.chevron.className += ' active';
      } else {
        this.$refs.chevron.className = this.$refs.chevron.className
          .split(' active')
          .join('');
      }
    },
  },
  methods: {
    onClose() {
      this.showToast = false;
    },
    onCtaListClose() {
      this.showCtaList = false;
    },
    onCtaListOptionSelect(id) {
      this.showCtaList = false;
      this.showToast = false;
      this.ctaClickHandler(id);
    },
    ctaClickHandler(id) {
      this.onCtaClick(id);
      this.showToast = false;
    },
  },
};
